import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink } from '@plone/volto/components';
import { Image } from 'semantic-ui-react';
import FadeInSection from '../../../theme/Animations/FadeInSection';
import { flattenToAppURL } from '@plone/volto/helpers';

const ProjektListing = ({ items, isEditMode, path }) => {
    const documents = items.filter(item => item['@type'] === 'Document');

    return (
        <FadeInSection>
            <div className="ui twelve column grid column-grid projekt-listing">
                {documents.map((item, index) => (
                    <div key={index} className={`three wide computer twelve wide mobile six wide tablet column column-blocks-wrapper `}>
                        <ConditionalLink item={item} condition={!isEditMode} className={`listing-kachel-small`}>
                            {item.preview_image && item.preview_image?.download && <Image src={flattenToAppURL(item.preview_image.download)} alt={item.alt || null} />}
                            {item.image_scales && item.image_scales.preview_image && item.image_scales.preview_image[0] && item.image_scales.preview_image[0].download && <Image src={flattenToAppURL(item['@id'] + "/" + item.image_scales.preview_image[0].download)} alt={item.alt || null} />}
                            {!item.preview_image && !item.preview_image?.download && !item.image_scales && !item.image_scales?.preview_image && item.title && <p>{item.title}</p> }
                        </ConditionalLink>
                    </div>
                ))}
            </div>
        </FadeInSection>
    );
};

ProjektListing.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    isEditMode: PropTypes.bool,
};

export default ProjektListing;
